import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import axios from "axios";
import SelectSingle from "react-select";

import customStyles from "../../../../assets/select/customStyles";

const SmartSignSettingsTypes = forwardRef((props, ref) => {
  const { data, type: settingsType } = props;

  const jwt = localStorage.getItem("JWT");
  const link = localStorage.getItem("link");
  axios.defaults.headers.common["Authorization"] = "Bearer " + jwt;

  const [selected, setSelected] = useState(null);
  const [originalId, setOriginalId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [types, setTypes] = useState([]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("lotTypes") || "[]");
    setTypes(stored);
  }, []);
  const options = useMemo(
    () =>
      types.map((t) => ({
        value: t.id,
        label: <div className="flex-iac settings-item">{t.name}</div>,
      })),
    [types],
  );

  const isDirty = () => {
    const currentId =
      selected?.value === undefined || selected?.value === null
        ? null
        : Number(selected.value);
    return currentId !== originalId;
  };

  const reset = () => {
    if (originalId === null) {
      setSelected(null);
    } else {
      const originalOption =
        options.find((o) => Number(o.value) === originalId) || null;
      setSelected(originalOption);
    }
  };

  const save = async () => {
    if (!isDirty() || saving || !selected) return;

    setSaving(true);

    try {
      const elementId = Number(data.id ?? data.Id ?? data.ids?.[0]);
      const selectedTypeId = Number(selected.value);

      if (!Number.isFinite(elementId) || !Number.isFinite(selectedTypeId)) {
        throw new Error("Invalid element or lot type id");
      }

      await axios.put(
        link + "/api/" + settingsType + "/LotType?elementId=" + elementId,
        [selectedTypeId],
        { headers: { "Content-Type": "application/json" } },
      );

      const response = await axios.get(
        link + "/api/" + settingsType + "/ById?id=" + elementId,
      );
      const savedTypeId =
        response.data?.lotTypes?.[0]?.id ??
        response.data?.LotTypes?.[0]?.Id;

      if (Number(savedTypeId) !== selectedTypeId) {
        throw new Error("Lot type was not persisted by the backend");
      }

      setOriginalId(selectedTypeId);
      setSelected(
        options.find((option) => Number(option.value) === selectedTypeId) ||
          selected,
      );
      if (props.onSaved) {
        props.onSaved(response.data);
      }
    } finally {
      setSaving(false);
    }
  };

  useImperativeHandle(ref, () => ({
    isDirty,
    save,
    reset,
  }));

  useEffect(() => {
    const typeId =
      data?.countingAreaLotTypeId ??
      data?.CountingAreaLotTypeId ??
      data?.lotTypeId ??
      data?.LotTypeId ??
      data?.typeId ??
      data?.TypeId ??
      data?.lotTypes?.[0]?.id ??
      data?.LotTypes?.[0]?.Id;

    if (typeId === undefined || typeId === null) {
      setSelected(null);
      setOriginalId(null);
      return;
    }

    const found =
      options.find((o) => Number(o.value) === Number(typeId)) || null;

    setSelected(found);
    setOriginalId(Number(typeId));
  }, [data, options]);

  function render() {
    return (
      <SelectSingle
        className="select"
        styles={customStyles}
        isSearchable={false}
        value={selected}
        onChange={setSelected}
        options={options}
        theme={(theme) => ({
          ...theme,
          borderRadius: 3,
          colors: { ...theme.colors, primary: "#20a0ff" },
        })}
      />
    );
  }

  return <div>{render()}</div>;
});

export default SmartSignSettingsTypes;
